import { loadingController } from "@ionic/vue";

export async function showLoader(message: string) {
	const loader = await loadingController.create({
		message,
	});
	await loader.present();

	async function dismiss() {
		await loader.dismiss();
	}

	return dismiss;
}
